module.exports = __webpack_public_path__ + "static/media/specialty.5cc0d151.jpg";